import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-excel",
  "use": "icon-excel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-excel\"><defs><style type=\"text/css\"></style></defs><path d=\"M955.73 204.8v750.93a68.47 68.47 0 0 1-68.26 68.27H136.53a68.47 68.47 0 0 1-68.27-68.27V68.27A68.47 68.47 0 0 1 136.53 0h614.4z\" fill=\"#4BAA74\" p-id=\"2553\" /><path d=\"M955.73 204.8H819.2a68.27 68.27 0 0 1-68.27-68.27V0z\" fill=\"#A5D5BA\" p-id=\"2554\" /><path d=\"M648.55 759.47a25.54 25.54 0 0 1-19.13-8.6L512 618.8 394.61 750.87a25.59 25.59 0 1 1-38.27-34l121.4-136.6-121.4-136.6a25.59 25.59 0 1 1 38.27-34L512 541.73l117.4-132.07a25.59 25.59 0 0 1 38.27 34l-121.4 136.6 121.4 136.6a25.6 25.6 0 0 1-19.13 42.6z\" fill=\"#FFFFFF\" p-id=\"2555\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/excel.svg
// module id = OLl3
// module chunks = 10